const ACTION_PREFIX = 'wizard/config'
const FORWARD = `${ACTION_PREFIX}/FORWARD`
const BACKWARD = `${ACTION_PREFIX}/BACKWARD`
const SET_TOTAL_STEPS = `${ACTION_PREFIX}/SET_TOTAL_STEPS`
const RESET = `${ACTION_PREFIX}/RESET`

const initialState = {
  step: 0,
  totalSteps: 0,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FORWARD: {
      const { step } = state
      const { steps } = action
      return { ...state, step: step + steps }
    }
    case BACKWARD: {
      const { step } = state
      const { steps } = action
      return { ...state, step: Math.max(0, step - steps) }
    }
    case SET_TOTAL_STEPS: {
      const { totalSteps } = action
      return { ...state, step: 0, totalSteps }
    }
    case RESET: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export const nextStep = () => ({ type: FORWARD, steps: 1 })
export const forward = (steps) => ({ type: FORWARD, steps })
export const prevStep = () => ({ type: BACKWARD, steps: 1 })
export const backward = (steps) => ({ type: BACKWARD, steps })
export const setTotalSteps = totalSteps => ({ type: SET_TOTAL_STEPS, totalSteps })
export const reset = () => ({ type: RESET })
